import createReducer from "../createReducer";

import {CallNotification} from 'actions/actionTypes';
import moment from "moment/moment";

const INITIAL_STATE = {
    count: 0,
    notificationList: [],
};

const reducer = createReducer(INITIAL_STATE, {
    [CallNotification.CHANGE_CALL_NOTIFICATION]: (state, action) => {
        const checkList = state.notificationList.filter((item)=> item.notificationId !== action.payload);
        state.notificationList = checkList;
        state.count = checkList.length;
    },

    [CallNotification.LOAD_CALL_NOTIFICATION_INFO_REQUEST_SUCCESS]: (state, action) => {
        const newNotification = {
            ...action.payload,
            notificationRegTime: moment().valueOf(),
        }
        if(action.payload.notificationValue.includes('호출')){
            state.notificationList.unshift(newNotification);
            state.count = state.count + 1;
        }
    },
});
export default reducer;
